/**
 * Normalize Google Places displayName (string or { text }).
 */
export function normalizePlaceName(name) {
  if (name == null) return '';
  if (typeof name === 'string') return name.trim();
  if (typeof name === 'object' && typeof name.text === 'string') {
    return name.text.trim();
  }
  return '';
}

/**
 * Build a user-facing label that keeps establishment/hotel names with the street address.
 * Example: "Hyatt Regency Nairobi Westlands, 38 Muthithi Road, Westlands, Nairobi"
 */
export function composePlaceLabel(name, formattedAddress) {
  const placeName = normalizePlaceName(name);
  const address = String(formattedAddress || '').trim();

  if (!placeName && !address) return '';
  if (!placeName) return address;
  if (!address) return placeName;

  const addressLower = address.toLowerCase();
  const nameLower = placeName.toLowerCase();
  if (addressLower.startsWith(nameLower)) {
    return address;
  }

  return `${placeName}, ${address}`;
}
